<template lang="pug">
  // メール変更画面
  #change-mail
    b-card(header-tag="header")
      change-mail-form
</template>

<script>
import ChangeMailForm from "@/components/supportSite/ChangeMailForm";

export default {
  name: "ChangeMail",
  components: {
    ChangeMailForm,
  }, 
}
</script>